import React, { useCallback, ReactNode } from 'react';
import arrayMutators from 'final-form-arrays';
import { Form } from 'react-final-form';
import { Decorator, ValidationErrors } from 'final-form';

import OnboardingWizardButtonsArea from './OnboardingWizardButtonsArea/OnboardingWizardButtonsArea';
import './OnboardingWizardContentWrapper.scss';

type Props = {
  previewSectionContent: ReactNode;
  children: ReactNode;
  initialValues: {};
  decorators?: Array<Decorator>;
  errorsDisableSubmit?: Function;
  onNextStep: Function;
  formValidate?: (values: any) => ValidationErrors | Promise<ValidationErrors>;
};

function OnboardingWizardContentWrapper({
  initialValues,
  onNextStep,
  formValidate,
  decorators,
  errorsDisableSubmit,
  children,
  previewSectionContent,
}: Props) {
  const handleNextStep = useCallback(params => onNextStep(params), [onNextStep]);

  const handleKeyPress = useCallback(event => {
    if (event.which === 13 /* Enter */) event.preventDefault();
  }, []);

  return (
    <Form
      mutators={{
        ...arrayMutators,
      }}
      decorators={decorators}
      initialValues={initialValues}
      onSubmit={handleNextStep}
      validate={formValidate}
    >
      {({ handleSubmit }) => (
        <form
          className="onboarding-wizard-page-wrapper-content h-100 d-flex pt-4 ml-lg-5"
          onKeyPress={handleKeyPress}
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <div className="onboarding-wizard-preview-section-wrapper">{previewSectionContent}</div>
          <div className="onboarding-wizard-content d-flex flex-column">
            {children}
            <OnboardingWizardButtonsArea errorsDisableSubmit={errorsDisableSubmit} />
          </div>
        </form>
      )}
    </Form>
  );
}
export default OnboardingWizardContentWrapper;
